import { createBrowserRouter, Navigate } from 'react-router-dom'
import {AuthLayout, OrganizerLayout, ParticipantLayout, GukLayout} from '../components/Layouts'
import PrivateRoute from '../components/Routing/PrivateRoute'
import Auth from '../pages/Auth'
import GukPages from '../pages/Guk'
import OrganizerPages from '../pages/Organizer'
import ParticipantPages from '../pages/Participant'
import NotFound from '../pages/NotFound'


const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/auth" replace />
  },
  {
    element: <PrivateRoute />,
    children: [
      {
        path: '/organizer',
        element: <OrganizerLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="active" replace />
          },
          {
            path: 'active',
            children: [
              {
                index: true,
                element: <OrganizerPages.Active />
              },
              {
                path: ':id/details',
                element: <OrganizerPages.Details />
              },
            ],
          },
          {
            path: 'closed',
            element: <OrganizerPages.Closed />
          }
        ]
      },
      {
        path: '/participant',
        element: <ParticipantLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="events" replace />
          },
          {
            path: 'events',
            element: <ParticipantPages.Events />
          },
          {
            path: 'events/:id/apply',
            element: <ParticipantPages.Apply />
          },
          {
            path: 'requests',
            element: <ParticipantPages.Requests />
          }
        ]
      },
      {
        path: '/guk',
        element: <GukLayout />,
        children: [
          {
            index: true,
            element: <GukPages.Main />
          }
        ]
      },
    ]
  },
  {
    path: '/auth',
    element: <AuthLayout />,
    children: [
      {
        index: true,
        element: <Auth.Main />
      },
      {
        path: ':mode',
        element: <Auth.Form />
      }
    ]
  },
  {
    path: '*',
    element: <NotFound />
  }
])

export default router
